export const isNearlyExpired = (files: Asset[]) => files.some(file => file.nearing_expiration_date === true);